import React, { useState } from 'react';
import { safeFetch } from './App';
import { Card, Button, FormField, Input, Textarea, Select, PageHeader } from './components/ui';

const TELEGRAM_URL = 'https://t.me/odednaftali';

export const Contact = ({ chatId }) => {
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [statusKind, setStatusKind] = useState('info'); // 'info' | 'success' | 'error'
    const [loading, setLoading] = useState(false);

    const subjects = [
        'שאלה כללית',
        'בעיה טכנית',
        'הצעה לשיפור',
        'בקשה להוספת עסק',
        'דיווח על תוכן לא הולם',
        'שיתוף פעולה',
        'אחר',
    ];

    const openTelegram = () => {
        window.open(TELEGRAM_URL, '_blank', 'noopener,noreferrer');
    };

    const handleSubmit = async () => {
        if (!message || !email) {
            setStatusKind('error');
            setStatus('צריך גם כתובת אימייל וגם הודעה');
            return;
        }
        setLoading(true);
        setStatus('');
        try {
            const res = await safeFetch('https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/contact-message', chatId, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, subject, message }),
            });
            if (res.ok) {
                setStatusKind('success');
                setStatus('ההודעה נשלחה בהצלחה — נחזור אליך בקרוב');
                setEmail(''); setSubject(''); setMessage('');
            } else {
                setStatusKind('error');
                setStatus('שגיאה בשליחה. אפשר לנסות שוב?');
            }
        } catch (err) {
            console.error('Error sending message:', err);
            setStatusKind('error');
            setStatus('שגיאה בשליחה. אפשר לנסות שוב?');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div dir="rtl" className="app-container py-10 sm:py-14">
            <div className="max-w-xl mx-auto">
                <PageHeader
                    eyebrow="צור קשר"
                    title="נשמח לשמוע מכם"
                    description="שאלה, רעיון או משוב — כל הודעה נקראת על ידי הצוות שלנו."
                    size="md"
                    className="mb-8"
                />

                <Card variant="elevated" padding="lg" className="mb-6">
                    <div className="space-y-3 text-center">

                        <Button onClick={openTelegram} variant="primary" size="lg" fullWidth>
                            פתיחת שיחה בטלגרם
                        </Button>
                    </div>
                </Card>

                <div className="flex items-center gap-3 my-6 text-ink-muted text-sm">
                    <div className="flex-1 h-px bg-line" />
                    <span>או שלחו הודעה</span>
                    <div className="flex-1 h-px bg-line" />
                </div>

                <Card variant="elevated" padding="lg">
                    <div className="space-y-5">
                        <FormField label="כתובת אימייל" required>
                            <Input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="example@mail.com"
                            />
                        </FormField>

                        <FormField label="נושא">
                            <Select value={subject} onChange={(e) => setSubject(e.target.value)}>
                                <option value="">בחרו נושא</option>
                                {subjects.map((subj) => (
                                    <option key={subj} value={subj}>{subj}</option>
                                ))}
                            </Select>
                        </FormField>

                        <FormField label="הודעה" required>
                            <Textarea
                                rows={5}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="כתבו כאן את מה שתרצו לשתף..."
                            />
                        </FormField>

                        {status && (
                            <div className={[
                                'rounded-lg border px-4 py-3 text-sm font-medium',
                                statusKind === 'success' && 'bg-success-50 border-success-100 text-success-700',
                                statusKind === 'error' && 'bg-danger-50 border-danger-100 text-danger-700',
                                statusKind === 'info' && 'bg-surface-muted border-line text-ink-muted',
                            ].filter(Boolean).join(' ')}>
                                {status}
                            </div>
                        )}

                        <Button onClick={handleSubmit} loading={loading} variant="secondary" size="lg" fullWidth>
                            שליחה
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};
